export default {
  "content": "<g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8A8 8 0 110 8a8 8 0 0116 0zM8 9.333a.669.669 0 01-.667-.666V4c0-.367.3-.667.667-.667.367 0 .667.3.667.667v4.667c0 .366-.3.666-.667.666zm-.747 2.08c0-.426.34-.746.747-.746.42 0 .753.32.753.746 0 .414-.34.754-.753.754a.747.747 0 01-.747-.754z\" fill=\"#028EB7\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};